var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0007 15.1715L18.4859 6.68545C18.8763 6.29499 19.5094 6.29498 19.9 6.68528C20.2907 7.07577 20.291 7.70925 19.9004 8.09987L10.7078 17.2924C10.3173 17.6829 9.68414 17.6829 9.29361 17.2924L4.34372 12.3425C3.95325 11.952 3.95325 11.319 4.34372 10.9285C4.73418 10.5381 5.36725 10.5381 5.75772 10.9285L10.0007 15.1715Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckWhite);
export default __webpack_public_path__ + "static/media/icon-check-white.a43fe2a69d835cc17bbfe62fa3852d41.svg";
export { ForwardRef as ReactComponent };